<template>
    <p-modal
        :button-label="buttonLabel"
        :icon-plus="isNew"
        size="xl"
        :label="pageTitle"
        :button-variant="buttonVariant"
        ref="editShippingCodeModal"
        name="shippingCodeModal"
        @ok.prevent="handleModalOk"
        @shown="loadData"
        @hide="checkDirtyBeforeModalClose($event, 'shippingCodeModal')"
        :disable-button="disabled"
        @hidden="resetModal"
        dialog-class="wide-shipping-modal-dialog"
    >
        <template v-slot:default>
            <p-form ref="form">
                <div
                    class="container-fluid content-wrapper"
                    v-if="shippingcode"
                >
                    <b-row>
                        <b-col cols="6">
                            <p-input
                                label="Shipping Name"
                                v-model="shippingcode.shippingCodeName"
                                rules="required|max:100"
                                :disabled="!isNew"
                            />
                        </b-col>
                        <b-col cols="3">
                            <p-checkbox
                                label="In-Store Pickup"
                                class="mt-3 pt-3"
                                v-model="shippingcode.isStorePickup"
                                @input="onStorePickupChange"
                            />
                        </b-col>
                        <b-col>
                            <p-select
                                label="Code Status"
                                data-type="isActiveOptions"
                                text-field="text"
                                v-model="shippingcode.isActive"
                            ></p-select>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="6">
                            <p-input
                                label="Code Description"
                                v-model="shippingcode.description"
                                rules="max:255"
                            />
                        </b-col>
                        <b-col>
                            <p-select
                                label="Shipping Method"
                                data-type="ShippingMethods"
                                text-field="text"
                                v-model="shippingcode.shippingMethodId"
                                :disabled="!isNew"
                                @input="getInputType()"
                            ></p-select>
                        </b-col>
                        <b-col>
                            <p-number
                                label="Display Priority"
                                v-model="shippingcode.priority"
                                input-type="integer"
                                rules="required|min_value:1|max_value:5"
                                left-align
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <p-card class="mt-2">
                                <p-table
                                    :foot-clone="isNew"
                                    no-footer-sorting
                                    foot-variant="light"
                                    :enable-row-selection="false"
                                    :items="shippingcode.shippingCodeDetails"
                                    :fields="computedFields"
                                    empty-text=""
                                    ref="detailTable"
                                >
                                    <template
                                        v-slot:cell(startRange)="{
                                            value,
                                            item,
                                            index
                                        }"
                                    >
                                        <p-number
                                            v-model="item.startRange"
                                            name="Start Order Qty"
                                            :ref="'startInputs_' + index"
                                            :inputType="inputType"
                                            rules="required|min_value:0"
                                            :disabled="true"
                                        >
                                        </p-number>
                                    </template>
                                    <template
                                        v-slot:cell(endRange)="{
                                            value,
                                            item,
                                            index
                                        }"
                                    >
                                        <p-number
                                            v-model.number="item.endRange"
                                            name="Ending Order Qty"
                                            :inputType="inputType"
                                            rules="required|min_value:0"
                                            :disabled="true"
                                            :ref="'endInputs_' + index"
                                        >
                                        </p-number>
                                    </template>
                                    <template
                                        v-slot:cell(shippingFee)="{
                                            value,
                                            item,
                                            index
                                        }"
                                    >
                                        <p-number
                                            v-model.number="item.shippingFee"
                                            name="Shipping Charge"
                                            input-type="money"
                                            :ref="'feeInputs_' + index"
                                            rules="required|min_value:0"
                                        >
                                        </p-number>
                                    </template>
                                    <!-- footer -->
                                    <template v-slot:foot(startRange)="data">
                                        <p-number
                                            v-model.number="newItem.startRange"
                                            name="Start Range"
                                            ref="newStartInput"
                                            :inputType="inputType"
                                            rules="required|min_value:0"
                                            class="text-end"
                                            :disabled="true"
                                        >
                                        </p-number>
                                    </template>

                                    <template v-slot:foot(endRange)="data">
                                        <p-number
                                            v-model.number="newItem.endRange"
                                            name="End Range"
                                            ref="newEndInput"
                                            :inputType="inputType"
                                            :rules="newItemEndRangeRules"
                                            @change="handleNewEndBlur(newItem)"
                                            :disabled="!isNew"
                                        >
                                        </p-number>
                                    </template>
                                    <template v-slot:foot(shippingFee)="data">
                                        <p-number
                                            v-model.number="newItem.shippingFee"
                                            name="Shipping Fee"
                                            ref="newFeeInput"
                                            input-type="money"
                                            rules="required|min_value:0"
                                            @keydown="
                                                handleNewFeeKeydown(
                                                    $event,
                                                    newItem
                                                )
                                            "
                                            @change="handleNewEndBlur(newItem)"
                                            class="text-end"
                                        >
                                        </p-number>
                                    </template>
                                </p-table>
                            </p-card>
                        </b-col>
                        <b-col cols="6">
                            <p-card class="mt-2">
                                <p-feature-flag ref="AccountingFlag" name="Accounting">
                                    <ShippingCodeGLCodeLocation
                                        :items="shippingcode.locations"
                                        :fields="fields"
                                        :filterChartOfAccounts="filterChartOfAccounts"
                                        :isStorePickup="shippingcode.isStorePickup"
                                        :selectedLocationId="Number(selectedLocationId)"
                                        @fulfillment-location-changed="onFulfillmentLocationChange" />
                                </p-feature-flag>
                            </p-card>
                        </b-col>
                    </b-row>
                </div>
            </p-form>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-row class="w-100">
                <b-col class="text-start">
                    <p-button
                        :is-busy="isBusy"
                        variant="outline-primary"
                        @click="cancel"
                        class="ms-2"
                    >
                        Cancel
                    </p-button>
                    <b-button
                        v-if="!isNew"
                        class="ms-2"
                        variant="outline-danger"
                        :disabled="isActive"
                        @click="deleteShippingCode"
                    >
                        Delete
                    </b-button>
                </b-col>
                <b-col class="mb-3 text-end">
                    <p-button
                        ref="btnSave"
                        :is-busy="isBusy"
                        variant="primary"
                        @click="ok"
                        class="me-2"
                        >Save</p-button
                    >
                </b-col>
            </b-row>
        </template>
    </p-modal>
</template>

<script>
import axios from 'axios';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import round from 'lodash/round';
import ShippingCodeGLCodeLocation from '@/components/ShippingCodeGLCodeLocation';
import { useAppStateStore } from '@/stores/appState.js';

export default {
    mixins: [NavigationGuard],
    components: {
        ShippingCodeGLCodeLocation
    },        
    props: {
        shippingCodeId: [String, Number],
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isBusy: false,
            shippingcode: null,
            inputType: 'money',
            maxRange: 100000,
            nextValueIncreament: 0.01,
            searchPrefill: null,
            newItem: {
                startRange: 0,
                endRange: 100000,
                shippingFee: null
            },
            isChangedEvent:true,
            fields:[
                {
                    key: 'locationName',
                    label: 'Location',
                    tdClass: 'reasonLocation'
                },
                {
                    key: 'glCode',
                    label: 'GL Code',
                }
            ]            
        };
    },
    watch: {
        shippingcode: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    },
    computed: {
        isNew() {
            return this.shippingCodeId === 'new';
        },
        pageTitle() {
            return this.isNew ? 'Add Shipping Code' : 'Edit Shipping Code';
        },
        buttonLabel() {
            return this.isNew ? 'Add' : 'Edit';
        },
        buttonVariant() {
            return this.isNew ? 'primary' : 'outline-primary';
        },
        isActive() {
            return this.shippingcode?.isActive;
        },
        newItemEndRangeRules() {
            return (
                'required|min_value:' +
                (this.shippingcode.shippingMethodId == 1?round(this.newItem.startRange + 0.01, 2):this.newItem.startRange) +
                '|max_value:100000'
            );
        },
        computedFields() {
            return [
                {
                    key: 'startRange',
                    label:
                        this.shippingcode.shippingMethodId == 1
                            ? 'Starting Order Value'
                            : 'Starting Order Qty'
                },
                {
                    key: 'endRange',
                    label:
                        this.shippingcode.shippingMethodId == 1
                            ? 'Ending Order Value'
                            : 'Ending Order Qty'
                },
                {
                    key: 'shippingFee',
                    label: 'Shipping Fee'
                }
            ];
        },
        selectedLocationId() {
            return useAppStateStore().getSelectedLocationId;
        }
    },
    methods: {
        onStorePickupChange(isChecked) {
            if (isChecked) {
                const mainLocationId = useAppStateStore().getSingleLocationId;
                this.shippingcode.locations.forEach(webFulfillmentLocation => {
                    webFulfillmentLocation.isSaleFulfillmentLocation = webFulfillmentLocation.locationId === mainLocationId;
                });
            } else {
                this.shippingcode.locations.forEach(webFulfillmentLocation => {
                    webFulfillmentLocation.isSaleFulfillmentLocation = false;
                });
            }
        },
        getInputType() {
            if(this.isNew && this.shippingcode.shippingCodeDetails.length > 0 && this.isChangedEvent){
                this.$bvModal
                .msgBoxConfirm('The rows will be cleared. Are you sure you want to the change the shipping method?')
                .then(value => {
                    if (value) {
                        this.shippingcode.shippingCodeDetails = [];
                        this.newItem = {
                            startRange: 0,
                            endRange: 100000,
                            shippingFee: null
                        };
                        this.setConfiguration();                        
                    }else{
                        this.shippingcode.shippingMethodId = this.shippingcode.shippingMethodId==1?2:1;
                        this.isChangedEvent=false;
                        this.setConfiguration();
                        return;
                    }
                })
            }else{
                this.isChangedEvent=true;
                this.setConfiguration();
            }
        },
        setConfiguration(){
            this.inputType = this.shippingcode.shippingMethodId == 1 ? 'money' : 'integer';
            this.maxRange = this.shippingcode.shippingMethodId == 1 ? 100000 : 500;
            this.nextValueIncreament = this.shippingcode.shippingMethodId == 1 ? 0.01 : 1;
            this.newItem.endRange = this.maxRange;
        },
        handleModalOk: async function() {
            if (!(await this.$refs.form.validate())) {
                return;
            }
            let finalShippingcode = JSON.parse(
                JSON.stringify(this.shippingcode)
            );
            
            // Convert chartOfAccountsId from 0 to null for locations to match the underlying data model, which uses null for unassigned GL codes
            if (finalShippingcode.locations) {
                finalShippingcode.locations.forEach(location => {
                    if (location.chartOfAccountsId === 0) {
                        location.chartOfAccountsId = null;
                    }
                });
            }
            
            if (this.isNew) {
                finalShippingcode.shippingCodeDetails.push({
                    startRange: this.newItem.startRange,
                    endRange: this.newItem.endRange,
                    shippingFee: this.newItem.shippingFee
                });
            }
            this.isBusy = true;

            axios
                .post('shippingcodes', finalShippingcode)
                .then(() => {
                    this.dataSaved();
                    this.$emit('result-updated');
                    this.$appSuccess(
                            `Shipping Code '${this.shippingcode.shippingCodeName}' saved successfully.`
                        )
                    this.$refs.editShippingCodeModal.hide();
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        loadData() {
            this.shippingcode = null;
            let promise = this.isNew
                ? axios.get('shippingcodes/new')
                : axios.get('shippingcodes', {
                      params: { id: this.shippingCodeId }
                  });

            promise
                .then(resp => {
                    this.shippingcode = resp.data;
                    this.getInputType();
                    if (!this.isNew) {
                        this.dataLoaded();
                    } else {
                        this.newItem = {
                            startRange: 0,
                            endRange: 100000,
                            shippingFee: null
                        };
                    }
                })
                .catch(() => {
                    this.$refs.editShippingCodeModal.hide();
                });
        },
        // Override the mixin's helper so the post-confirm hide goes straight
        // through the modal ref instead of the $bvModal name registry — the
        // registry indirection was leaving the modal open after the user
        // confirmed discarding changes.
        checkDirtyBeforeModalClose(bvModalEvt) {
            const trigger = bvModalEvt?.trigger;
            // The Save button fires the modal's built-in `ok` (trigger 'ok').
            // handleModalOk does the real save and closes the modal itself once
            // the POST succeeds, so swallow the built-in ok-close here and never
            // show the discard prompt for it.
            if (trigger === 'ok') {
                bvModalEvt.preventDefault();
                return;
            }
            // Only a genuine user dismissal should warn about unsaved changes.
            // Our own post-save/delete `.hide()` comes through with trigger null
            // (bootstrap-vue-next's default) — let those close cleanly.
            const userDismissed = ['backdrop', 'cancel', 'close', 'esc'].includes(trigger);
            if (!userDismissed || !this.formIsDirty) return;
            bvModalEvt.preventDefault();
            if (this._dirtyCheckInProgress) return;
            this._dirtyCheckInProgress = true;
            this.$bvModal.msgBoxConfirm([this.displayMessage]).then(value => {
                this._dirtyCheckInProgress = false;
                if (value) {
                    this.dataSaved();
                    this.$nextTick(() => {
                        this.$refs.editShippingCodeModal?.hide();
                    });
                }
            });
        },
        resetModal() {
            this.$emit('result-updated');
            this.$refs.editShippingCodeModal.hide();
        },
        deleteShippingCode() {
            if (!this.shippingcode.isActive) {
                this.$bvModal
                    .msgBoxConfirm(
                        'Are you sure you want to delete this shipping code?',
                        {
                            okVariant: 'danger',
                            okTitle: 'Delete',
                            cancelTitle: 'Cancel'
                        }
                    )
                    .then(value => {
                        if (value) {
                            axios
                                .post('shippingcodes/delete', this.shippingcode)
                                .then(resp => {
                                    if (resp) {
                                        this.dataSaved();
                                        this.$appSuccess(
                                                `Shippingcode '${this.shippingcode.shippingCodeName}' deleted successfully.`
                                            )
                                        this.$refs.editShippingCodeModal.hide();
                                    }
                                });
                        }
                    });
            }
        },
        handleNewFeeKeydown(e, item) {
            if (this.enterOrTab(e.code) && item.endRange < this.maxRange) {
                e.preventDefault();

                if (e.shiftKey == true) {
                    this.$refs['newEndInput'].focus();
                    return;
                }
                if (item.endRange < this.maxRange) {
                    this.addItem(item);
                }
            }
        },
        handleNewEndBlur(item) {
            if (item.endRange < this.maxRange) {
                this.addItem(item);
            }
        },
        async addItem(item) {
            if (!(await this.$refs.form.validate())) {
                return;
            }

            this.shippingcode.shippingCodeDetails.push({
                startRange: item.startRange,
                endRange: item.endRange,
                shippingFee: item.shippingFee
            });

            this.clearNewItem(item);
            this.$refs['newEndInput'].focus();
        },
        clearNewItem(item) {
            // Coerce in case anything upstream handed us a string — '3000' + 0.01
            // would string-concat to '30000.01' and poison the min_value rule.
            this.newItem.startRange = round(Number(item.endRange) + this.nextValueIncreament, 2);
            this.newItem.endRange = this.maxRange;
            this.newItem.shippingFee = null;
            this.newItem._rowVariant = null;
        },
        enterOrTab(code) {
            return code == 'Enter' || code == 'Tab' || code == 'NumpadEnter';
        },
        filterChartOfAccounts(chartOfAccount) {
            return chartOfAccount.type == 'Web Shipping' || chartOfAccount.type == null;        
        },
        onFulfillmentLocationChange(locationId) {
            // Update locations to set isSaleFulfillmentLocation flag on the selected location
            if (this.shippingcode.locations) {
                this.shippingcode.locations.forEach(location => {
                    location.isSaleFulfillmentLocation = location.locationId === locationId;
                });
            }
        }
    }
};
</script>

<style lang="scss">
.wide-shipping-modal-dialog {
    max-width: 1700px !important;
}
</style>

<style scoped lang="scss">
@import '@/styles/app/common/variables.scss';
.select-filter :deep(.custom-select ) {
    height: 34px;
    min-width: 135px;
}
</style>
